import type { BlockColumn, BlockEntity } from "../block-definitions.js";

export interface IndustryModel {
  id: string;
  name: string;
  industry: string;
  description: string;
  dependencies: string[];
  entities: BlockEntity[];
  tags: string[];
  sourceReferences: { title: string; url: string }[];
  assumptions: string[];
}

/** Each line is a declared field: name | domain or >table.column | description.
 * A trailing ? on the domain marks an optional field. References are explicit
 * template ports, never inferred from destination names. */
export function entity(name: string, title: string, description: string, fields: string, business: string[], rules: string): BlockEntity {
  const columns: BlockColumn[] = [{ name: "id", domain: "ID", nullable: false, description: `Stable internal identity of ${title.toLowerCase()}; not a business key.` }];
  for (const line of fields.trim().split("\n").filter(Boolean)) {
    const [fieldName, raw, explanation] = line.split("|").map(s => s.trim());
    if (!fieldName || !raw || !explanation) throw new Error(`Incomplete field in ${name}: ${line}`);
    const nullable = raw.endsWith("?"), type = nullable ? raw.slice(0, -1) : raw;
    const reference = type.startsWith(">") ? type.slice(1) : undefined;
    columns.push({ name: fieldName, domain: reference ? "ID" : type, nullable, description: explanation, ...(reference ? { reference } : {}) });
  }
  return { name, title, description, referenceMode: "explicit", columns, keys: [{ role: "primary", members: ["id"] }, ...business.map(key => ({ role: "business", members: key.split(",").map(v => v.trim()) }))], rules };
}

export const commonAssumptions = [
  "Reference design, not a certified industry standard or operational application.",
  "Review business-key scopes, retention, optionality and local policies before implementation.",
  "Amounts require the recorded currency; quantities require their recorded unit. No implicit conversion or derived balance is enforced.",
  "Cross-row, temporal, quantity conservation, accounting and authorization rules require target application enforcement.",
];
